import React, { useRef, useState, useEffect } from 'react';

import { Dropdown, Navbar, Nav, Container, Button } from 'react-bootstrap';
import ReservationCalendar from './ReservationCalendar';
import PhotoGallery from './PhotoGallery';
import GoogleMapsComponent from './GoogleMapsComponent';
import Contact from './Contact';

import AmenitiesGrid from './Amenities';


function Header({ t, lang, setLang }) {

  const [menuOpen, setMenuOpen] = useState(false)

  const flags = [
    { code: 'en', emoji: '🇬🇧', name: 'English' },
    { code: 'es', emoji: '🇪🇸', name: 'Español' },
    { code: 'ca', emoji: '🇦🇩', name: 'Català' },
    { code: 'pl', emoji: '🇵🇱', name: 'Polski' }
  ];

  const aboutRef = useRef(null);
  const locationRef = useRef(null);
  const featuresRef = useRef(null);
  const contactRef = useRef(null);
  const reservationRef = useRef(null);

  const [showScrollButton, setShowScrollButton] = useState(false);
  const [weather, setWeather] = useState(null);

  // Function to handle scrolling to a section
  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Show/hide scroll-to-top button
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const res = await fetch('https://api.open-meteo.com/v1/forecast?latitude=40.05&longitude=0.07&current_weather=true&daily=temperature_2m_max,temperature_2m_min,windspeed_10m_max&timezone=auto');
        const data = await res.json();
        setWeather({
          current: data.current_weather,
          tomorrow: {
            maxTemp: data.daily.temperature_2m_max[1],
            minTemp: data.daily.temperature_2m_min[1],
            wind: data.daily.windspeed_10m_max[1]
          }
        });
      } catch (err) {
        console.error('Weather fetch error:', err);
      }
    };
    fetchWeather();
  }, []);

  const weatherIcons = {
    0: '☀️',      // Clear sky
    1: '🌤️',     // Mainly clear
    2: '⛅',      // Partly cloudy
    3: '☁️',      // Overcast
    45: '🌫️',     // Fog
    48: '🌫️',
    51: '🌦️',     // Drizzle
    61: '🌧️',     // Rain
    66: '🌨️',     // Freezing rain
    71: '❄️',      // Snow fall
    95: '⛈️',     // Thunderstorm
  };

  const iconToday = weatherIcons[weather?.current?.weathercode] || '🌡️';
  const iconTomorrow = weatherIcons[weather?.tomorrow?.weathercode] || '🌡️';
  const weatherToday = weather?.current?.temperature || '🌡️';
  return (
    <>

      <Navbar expand="lg" bg="light" variant="light" fixed="top" >

        <Container>
          <Navbar.Brand href="#">Villa Aleksandra {iconToday}{weatherToday}°C&nbsp; - Benicassim</Navbar.Brand>


          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? '✕' : '☰'}
          </Navbar.Toggle>

          <Navbar.Collapse id="basic-navbar-nav" className="align-items-center">


            <Nav className="flex-column flex-lg-row align-items-start ps-3 ps-lg-0 custom-offset menu">

              <Nav.Link onClick={() => scrollToSection(aboutRef)}> <div dangerouslySetInnerHTML={{ __html: t('menu.about') }} /></Nav.Link>
              <Nav.Link onClick={() => scrollToSection(locationRef)}>{t('menu.location')}</Nav.Link>
              <Nav.Link onClick={() => scrollToSection(featuresRef)}>{t('menu.features')}</Nav.Link>
              <Nav.Link onClick={() => scrollToSection(contactRef)}>{t('menu.contact')}</Nav.Link>

            
              
            </Nav>
            {/* Language select for mobile */}
            <div className="language-select-mobile w-100 text-center">
              <Dropdown>
                <Dropdown.Toggle variant="light" className="w-100">
                  🌐 Languages
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100 text-center">
                  {flags.map(({ code, name, emoji }) => (
                    <Dropdown.Item key={code} onClick={() => setLang(code)}>
                      {emoji} {name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>



            <div className="flags d-none d-lg-flex  align-items-center ">
          
          {flags.map(({ code, emoji, name }) => (
            <button
              key={code}
              onClick={() => setLang(code)}
              className={`btn btn-sm ${lang === code ? 'btn-secondary' : 'btn-outline-secondary'}`}
              title={name}
              style={{
                fontSize: '20px',
                background: lang === code ? '#ddd' : 'transparent',
                border: '1px solid #ccc',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              {emoji}
            </button>
          ))}
        </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Sections */}

      <Container className="content">
        {/* Reservation section - First on mobile */}
        <section ref={reservationRef} className="section" id="reservation">
          <ReservationCalendar translate={t} lang={lang} />
        </section>

        {/* About section with PhotoGallery */}
        <section ref={aboutRef} className="section" id="about">
          <PhotoGallery />
          <h2>{t('welcome.title')}</h2>
          <p className="welcome">
            <div dangerouslySetInnerHTML={{ __html: t('welcome.introduction') }} />
          </p>
        </section>

        <section ref={locationRef} className="section" id="location">
          <h2>{t('location.title')}</h2>
          <p>{t('location.content')}</p>
          <GoogleMapsComponent />
        </section>

        <section ref={featuresRef} className="section" id="features">
          <h2>{t('features.title')}</h2>
          <p>{t('features.content')}</p>
          <AmenitiesGrid translate={t} />
        </section>

        <section ref={contactRef} className="section" id="contact">
          <h2>{t('contact.title')}</h2>
          <p>{t('contact.content')}</p>
          <Contact translate={t} lang={lang} />
        </section>
      </Container>

      {/* Scroll-to-top button */}
      {showScrollButton && (
        <Button className="scroll-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        </Button>
      )}
    </>
    
  );
   
}

export default Header;
